import {
  dateFormatter,
  detailDateFormatter,
  dateFormatter2,
  chartDateFormatter4,
  chartDateFormatter5,
  chartDateFormatter6,
  chartDateFormatter7,
  chartDateFormatter8,
  chartDateFormatter9,
  chartDateFormatter10,
  chartDateFormatter11,
  chartDateFormatter12,
  chartDateFormatter13,
  chartDateFormatter14,
  chartDateFormatter15,
  chartDateFormatter16,
  chartDateFormatter17,
  chartDateFormatter18,
  chartDateFormatter19
} from 'utils/common'
import { EnumType } from 'json-to-graphql-query';
import { QUERY_TEMPLATES } from './editor/sqlQueries'

// CHART TYPE
const CHART_TYPE_DICT = {
  LINE: 'line',
  AREA: 'area',
  BAR: 'bar',
  PIE: 'pie',
  DOUGHNUT: 'doughnut',
  GAUGE: 'gauge',
  TABLE: 'table',
  CARD: 'card',
  HEATMAP: 'heatmap',
  MAP: 'map',
  INSIGHTS: 'insights'
}

export const CHART_TYPE = {
  ...CHART_TYPE_DICT,
  OPTIONS: [
    { value: CHART_TYPE_DICT.LINE, label: 'Line' },
    { value: CHART_TYPE_DICT.AREA, label: 'Area' },
    { value: CHART_TYPE_DICT.BAR, label: 'Bar' },
    { value: CHART_TYPE_DICT.PIE, label: 'Pie' },
    { value: CHART_TYPE_DICT.DOUGHNUT, label: 'Donut' },
    { value: CHART_TYPE_DICT.GAUGE, label: 'Gauge' },
    { value: CHART_TYPE_DICT.CARD, label: 'Card' },
    { value: CHART_TYPE_DICT.TABLE, label: 'Table' },
    { value: CHART_TYPE_DICT.HEATMAP, label: 'Heatmap' },
    { value: CHART_TYPE_DICT.MAP, label: 'Map' },
    { value: CHART_TYPE_DICT.INSIGHTS, label: 'Insights' },
  ]
}

// CHART INTERVAL
const CHART_INTERVAL_DICT = {
  DAY: 'Days',
  MINUTE: 'Minutes',
  HOUR: 'Hours',
  WEEK: 'Weeks',
  MONTH: 'Months',
  YEAR: 'Years',
}

export const CHART_INTERVAL = {
  ...CHART_INTERVAL_DICT,
  QUANTITY: 1,
  DEFAULT: CHART_INTERVAL_DICT.DAY,
  OPTIONS: [
    { value: CHART_INTERVAL_DICT.MINUTE, label: CHART_INTERVAL_DICT.MINUTE },
    { value: CHART_INTERVAL_DICT.HOUR, label: CHART_INTERVAL_DICT.HOUR },
    { value: CHART_INTERVAL_DICT.DAY, label: CHART_INTERVAL_DICT.DAY },
    { value: CHART_INTERVAL_DICT.WEEK, label: CHART_INTERVAL_DICT.WEEK },
    { value: CHART_INTERVAL_DICT.MONTH, label: CHART_INTERVAL_DICT.MONTH },
    { value: CHART_INTERVAL_DICT.YEAR, label: CHART_INTERVAL_DICT.YEAR },
  ]
}

export const CHART_LEGEND = {
  DEFAULT: 'none',
  OPTIONS: [
    { value: 'below', label: 'Below' },
    { value: 'right', label: 'Right Side' },
    { value: 'none', label: 'None' },
  ]
}

export const CHART_LAYOUT = {
  DEFAULT: 'sideBySide',
  OPTIONS: [
    { value: 'stacked', label: 'Stacked' },
    { value: 'sideBySide', label: 'Side-by-Side' },
  ]
}

export const CHART_DATA_SOURCE = {
  DEFAULT: 'sideBySide',
  OPTIONS: [
    { value: 'dashboard', label: 'Entire Dashboard' },
    { value: 'charts', label: 'Specific Chart' },
  ]
}

export const CHART_INSIGHT_MODE = {
  DEFAULT: 'Briefing',
  OPTIONS: [
    { value:  'briefing', label: 'Briefing' },
    { value:  'keyFinding', label: 'Key Finding' },
  ]
}

export const KEY_FINDING_INCLUDE = {
  DEFAULT: 'locations',
  OPTIONS: [
    { value: 'locations', label: 'Locations' },
    { value: 'timeRange', label: 'Time range' },
    { value: 'trend', label: 'Trend' },
  ]
}

export const KEY_FINDING_TEXT_SIZE = {
  DEFAULT: 'large',
  OPTIONS: [
    {
      label: 'Small',
      value: 'small'
    },
    {
      label: 'Medium',
      value: 'medium'
    },
    {
      label: 'Large',
      value: 'large'
    },
  ]
}

export const BRIEFING_SUMMARY_INCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'locations', label: 'Locations' },
    { value: 'oneKeyNumber', label: 'One key number' },
    { value: 'trend', label: 'Trend' },
    { value: 'confidence', label: 'Confidence' },
  ]
}

export const BRIEFING_SUMMARY_FORMAT = {
  DEFAULT: 'short',
  OPTIONS: [
    { value: 'short', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'long', label: 'Long' },
  ]
}

export const BRIEFING_CHANGE_DRIVERS_INCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'topContributors', label: 'Top contributors' },
    { value: 'directionOnly', label: 'Direction only' },
    { value: 'correlations', label: 'Correlations' },
  ]
}

export const BRIEFING_CHANGE_DRIVERS_FOCUS_ON = {
  DEFAULT: 'segments',
  OPTIONS: [
    { value: 'segments', label: 'Segments' },
    { value: 'metrics', label: 'Metrics' },
    { value: 'both', label: 'Both' },
  ]
}

export const BRIEFING_CHANGE_DRIVERS_FORMAT = {
  DEFAULT: 'short',
  OPTIONS: [
    { value: 'short', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'long', label: 'Long' },
  ]
}

export const BRIEFING_CHANGE_DRIVERS_CHANGE_SENSITIVITY = {
  DEFAULT: 'off',
  OPTIONS: [
    { value: 'off', label: 'Off' },
    { value: 'fivePercent', label: '5%' },
    { value: 'tenPercent', label: '10%' },
    { value: 'twentyPercent', label: '20%' },
  ]
}

export const BRIEFING_ANOMALY_RADAR_INCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'spikes', label: 'Spikes' },
    { value: 'drops', label: 'Drops' },
    { value: 'regimeShifts', label: 'Regime shifts' },
    { value: 'missingData', label: 'Missing data' },
  ]
}

export const BRIEFING_ANOMALY_RADAR_EXCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'weekends', label: 'Weekends' },
    { value: 'nights', label: 'Nights' },
  ]
}

export const BRIEFING_ANOMALY_RADAR_FORMAT = {
  DEFAULT: 'short',
  OPTIONS: [
    { value: 'short', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'long', label: 'Long' },
  ]
}

export const BRIEFING_ANOMALY_RADAR_CHANGE_SENSITIVITY = {
  DEFAULT: 'none',
  OPTIONS: [
    { value: 'none', label: 'None' },
    { value: 'significant', label: 'Significant' },
  ]
}

export const BRIEFING_PATTERN_FINDER_INCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'dailyCycles', label: 'Daily cycles' },
    { value: 'weeklyCycles', label: 'Weekly cycles' },
    { value: 'onlyWeekdays', label: 'Only weekdays' },
  ]
}

export const BRIEFING_PATTERN_FINDER_FORMAT = {
  DEFAULT: 'long',
  OPTIONS: [
    { value: 'short', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'long', label: 'Long' },
  ]
}

export const BRIEFING_PATTERN_FINDER_CHANGE_SENSITIVITY = {
  DEFAULT: 'none',
  OPTIONS: [
    { value: 'none', label: 'None' },
    { value: 'significant', label: 'Significant' },
  ]
}

export const BRIEFING_TIMELINE_OF_EVENTS_INCLUDE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'dateValues', label: 'Date values' },
    { value: 'calenderWeek', label: 'Calendar week' },
  ]
}

export const BRIEFING_TIMELINE_OF_EVENTS_FORMAT = {
  DEFAULT: 'timestampedBullets',
  OPTIONS: [
    { value: 'timestampedBullets', label: 'Timestamped bullets' },
    { value: 'earlyMidLate', label: 'Early / Mid / Late' },
    { value: 'narrativeParagraph', label: 'Narrative paragraph' },
  ]
}

export const BRIEFING_PROPOSE_ACTIONS_TYPE = {
  DEFAULT: [],
  OPTIONS: [
    { value: 'investigate', label: 'Investigate' },
    { value: 'mitigate', label: 'Mitigate' },
    { value: 'monitor', label: 'Monitor' },
  ]
}

export const BRIEFING_PROPOSE_ACTIONS_FORMAT = {
  DEFAULT: 'threeActionBullets',
  OPTIONS: [
    { value: 'threeActionBullets', label: 'Three action bullets' },
    { value: 'checkList', label: 'Checklist' },
  ]
}

export const DATA_MODE = {
  DEFAULT: 'raw',
  OPTIONS: [
    { value: 'raw', label: 'Raw data' },
    { value: 'aggregated', label: 'Aggregated data' },
  ]
}

export const CHART_FORMAT = {
  DEFAULT: 'Default',
  OPTIONS: [
    { value: 'Default', label: 'Default' },
    { value: '10', label: '10' },
    { value: '100', label: '100' },
    { value: '1000', label: 'k(thousands)' },
    { value: '1000000', label: 'm(millions)' },
    { value: '1000000000', label: 'b(billions)' },
  ]
}

export const CHART_FONT_SIZE = {
  DEFAULT: 'Default',
  OPTIONS: [
    { value: 'Default', label: 'Medium (Default)' },
    { value: 'Small', label: 'Small' },
    { value: 'Large', label: 'Large' },
  ]
}

export const CHART_DECIMAL = {
  DEFAULT: 2,
  OPTIONS: [
    { value: 'fromData', label: 'Text / From Data' },
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
  ],
  hasBorder: true
}

export const CHART_LINE_WIDTH = {
  DEFAULT: 'Auto',
  OPTIONS: [
    { value: 'Auto', label: 'Auto' },
    { value: 1, label: '1px' },
    { value: 2, label: '2px' },
    { value: 3, label: '3px' },
    { value: 4, label: '4px' },
    { value: 5, label: '5px' },
  ]
}

export const CHART_XAXIS_STEP = {
  DEFAULT: 'Auto',
  OPTIONS: [
    { value: 'Auto', label: 'Auto' },
    { value: 15, label: '15 min' },
    { value: 30, label: '30 min ' },
    { value: 60, label: '1 hr' },
  ]
}

export const CHART_BREAKDOWN_TYPE = {
  DEFAULT: '',
  OPTIONS: [
    { value: 'compare_streams', label: 'Compare streams' },
    { value: 'by_category', label: 'By category' },
  ]
}

export const CHART_FORMAT_SELECTOR = {
  DEFAULT: 'raw',
  OPTIONS: [
    { value: 'raw', label: 'Default (raw)' },
    { value: 'currency', label: 'Currency' },
    { value: 'percent', label: 'Percent' },
    { value: '1000', label: 'Thousands' },
    { value: '1000000', label: 'Millions' },
  ]
}

export const CHART_TIME_GRID_SELECTOR = {
  DEFAULT: 'hour_x_weekday',
  OPTIONS: [
    { value: 'hour_x_weekday', label: 'Hour of day × Weekday' },
    { value: 'hour_x_date', label: 'Hour of day × Date' },
    { value: 'dow_x_wom', label: 'Day of week × Week of month' },
    { value: 'dom_x_month', label: 'Day of month × Month' },
    { value: 'woy_x_year', label: 'Week of year × Year' },
  ]
}

export const CHART_LABEL_ROTATION = {
  DEFAULT: 'auto',
  OPTIONS: [
    { value: 'auto', label: 'Auto' },
    { value: 45, label: '45 deg' },
    { value: 90, label: '90 deg' },
    { value: '0', label: 'Off' },
  ]
}
export const CHART_THRESHOLD_TYPE = {
  DEFAULT: 'absolute',
  OPTIONS: [
    { value: 'percent', label: 'Percent' },
    { value: 'absolute', label: 'Absolute' }
  ],
  LABEL_OPTIONS: [
    { value: 'percent', label: 'Percent' },
    { value: 'absolute', label: 'Absolute' },
    { value: 'label', label: 'Match Value' }
  ],
  SINGLE_OPTIONS: [
    { value: 'absolute', label: 'Absolute' },
    { value: 'label', label: 'Match Value' }
  ]
}

export const COLORING_TYPE = {
  DEFAULT: 'percent',
  OPTIONS: [
    { value: 'percent', label: 'Percent' },
    { value: 'absolute', label: 'Absolute' }
  ]
}

export const CHART_DATE_FORMAT = {
  DEFAULT: 'dateFormatter2',
  OPTIONS: [
    { value: 'dateFormatter2', label: dateFormatter2(new Date(), true) },
    { value: 'dateFormatter', label: dateFormatter(new Date(), true) },
    { value: 'dateFormatter3', label: detailDateFormatter(new Date(), true) },
    { value: 'chartDateFormatter4', label: chartDateFormatter4(new Date()) },
    { value: 'chartDateFormatter5', label: chartDateFormatter5(new Date()) },
    { value: 'chartDateFormatter6', label: chartDateFormatter6(new Date()) },
    { value: 'chartDateFormatter7', label: chartDateFormatter7(new Date()) },
    { value: 'chartDateFormatter8', label: chartDateFormatter8(new Date()) },
    { value: 'chartDateFormatter9', label: chartDateFormatter9(new Date()) },
    { value: 'chartDateFormatter10', label: chartDateFormatter10(new Date()) },
    { value: 'chartDateFormatter11', label: chartDateFormatter11(new Date()) },
    { value: 'chartDateFormatter12', label: chartDateFormatter12(new Date()) },
    { value: 'chartDateFormatter13', label: chartDateFormatter13(new Date()) },
    { value: 'chartDateFormatter14', label: chartDateFormatter14(new Date()) },
    { value: 'chartDateFormatter16', label: chartDateFormatter16(new Date()) },
    { value: 'chartDateFormatter17', label: chartDateFormatter17(new Date()) },
    { value: 'chartDateFormatter18', label: chartDateFormatter18(new Date()) },
    { value: 'chartDateFormatter19', label: chartDateFormatter19(new Date()) },
  ]
}

export const CHART_DATE_FORMAT2 = {
  DEFAULT: 'dateFormatter2',
  OPTIONS: [
    { value: 'dateFormatter2', label: dateFormatter2(new Date()) },
    { value: 'chartDateFormatter4', label: chartDateFormatter4(new Date()) },
  ]
}

// Dynamic date format options based on timeGrid selection
export const getDateFormatOptionsByTimeGrid = (timeGrid) => {
  const baseOptions = [
    { value: 'dateFormatter2', label: dateFormatter2(new Date()) },
    { value: 'chartDateFormatter4', label: chartDateFormatter4(new Date()) },
  ];

  switch (timeGrid) {
    case 'hour_x_weekday':
      return [
        { value: 'shortWeek', label: 'Sun' }, // Sun
        { value: 'fullWeek', label: 'Sunday' }, // Sunday
      ];

    case 'hour_x_date':
      return [
        { value: 'chartDateFormatter16', label: chartDateFormatter16(new Date()) }, // MM D
        { value: 'chartDateFormatter17', label: chartDateFormatter17(new Date()) }, // D MM
        { value: 'chartDateFormatter18', label: chartDateFormatter18(new Date()) }, // D MMM
        { value: 'chartDateFormatter19', label: chartDateFormatter19(new Date()) }, // MMM D
        { value: 'chartDateFormatter15', label: chartDateFormatter15(new Date()) }, // MMM DD
        { value: 'chartDateFormatter4', label: chartDateFormatter4(new Date()) }, // DD/MM/YYYY
        { value: 'dateFormatter2', label: dateFormatter2(new Date()) }, // D MMM, YYYY
      ];

    case 'dow_x_wom':
      return [
        { value: 'shortWeek', label: 'Sun' }, // Sun
        { value: 'fullWeek', label: 'Sunday' }, // Sunday
      ];

    case 'dom_x_month':
      return [
        { value: 'shortMonth', label: 'Jan' }, // Jan
        { value: 'fullMonth', label: 'January' }, // January
      ];

    case 'woy_x_year':
      return [
        { value: 'year', label: 2025 }, // 2025
      ];

    default:
      return baseOptions;
  }
}

export const CHART_MODE = {
  DEFAULT: 'mono',
  OPTIONS: [
    { value: 'mono', label: 'Mono Color' },
    { value: 'multi', label: 'Multi Color' }
  ]
}

export const RELATIVE_TIME_RANGE = {
  OBJ_DEF: { label: '', start: '', end: '', timeInterval: '', timeQuantity: 0 },
  DASHBOARD_DEFAULT: { label: 'Last 1 month', start: '', end: '', timeInterval: CHART_INTERVAL.HOUR, timeQuantity: 1 },
  CHART_DEFAULT: { label: 'Dashboard default', start: '', end: '', timeInterval: '', timeQuantity: 0 },
  OPTIONS: [
    { label: 'Dashboard default', start: '', end: '', timeInterval: '', timeQuantity: 0 },
    { label: 'Last 5 minutes', start: '', end: '', timeInterval: CHART_INTERVAL.MINUTE, timeQuantity: 5 },
    { label: 'Last 15 minutes', start: '', end: '', timeInterval: CHART_INTERVAL.MINUTE, timeQuantity: 15 },
    { label: 'Last 30 minutes', start: '', end: '', timeInterval: CHART_INTERVAL.MINUTE, timeQuantity: 30 },
    { label: 'Last 1 hour', start: '', end: '', timeInterval: CHART_INTERVAL.HOUR, timeQuantity: 1 },
    { label: 'Last 3 hours', start: '', end: '', timeInterval: CHART_INTERVAL.HOUR, timeQuantity: 3 },
    { label: 'Last 6 hours', start: '', end: '', timeInterval: CHART_INTERVAL.HOUR, timeQuantity: 6 },
    { label: 'Last 12 hours', start: '', end: '', timeInterval: CHART_INTERVAL.HOUR, timeQuantity: 12 },
    { label: 'Last 1 day', start: '', end: '', timeInterval: CHART_INTERVAL.DAY, timeQuantity: 1 },
    { label: 'Last 7 days', start: '', end: '', timeInterval: CHART_INTERVAL.DAY, timeQuantity: 7 },
    { label: 'Last 15 days', start: '', end: '', timeInterval: CHART_INTERVAL.DAY, timeQuantity: 15 },
    { label: 'Last 1 month', start: '', end: '', timeInterval: CHART_INTERVAL.MONTH, timeQuantity: 1 },
    { label: 'Last 3 months', start: '', end: '', timeInterval: CHART_INTERVAL.MONTH, timeQuantity: 3 },
    { label: 'Last 6 months', start: '', end: '', timeInterval: CHART_INTERVAL.MONTH, timeQuantity: 6 },
  ]
}

export const CHART_COLORING = {
  DEFAULT: 'background',
  OPTIONS: [
    { value: 'background', label: 'Background' },
    { value: 'font', label: 'Font' },
    { value: 'indicatorBar', label: 'Indicator Bar' },
    { value: '', label: 'None' }
  ]
}

export const COLOR_TIERS = {
  DEFAULT: 1,
  OPTIONS: [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
  ]
}

export const CARD_TYPE = {
  DEFAULT: 'filledCard',
  OPTIONS: [
    { value: 'filledCard', label: 'Filled card', isDefault: true },
    { value: 'coloredText', label: 'Colored text', isDefault: false },
    { value: 'indicator', label: 'Indicator', isDefault: false }
  ]
}

export const MAP_TYPE = {
  DEFAULT: 'roadmap',
  OPTIONS: [
    { value: 'roadmap', label: 'Simple', isDefault: true },
    { value: 'satellite', label: 'Satellite', isDefault: false }
  ]
}

export const LABEL_DISPLAY = {
  DEFAULT: 'value',
  OPTIONS: [
    { value: 'value', label: 'Value', isDefault: true },
    { value: 'percent', label: 'Percent', isDefault: false },
  ]
}

export const COMPARATOR = {
  DEFAULT: '>',
  OPTIONS: [
    { label: ">", value: ">" },
    { label: ">=", value: ">=" },
    { label: "<", value: "<" },
    { label: "<=", value: "<=" },
    { label: "=", value: "=" },
    { label: "!=", value: "!=" }
  ]
}

export const METRIC = {
  OPTION_TRANSFORMER: (metrics, tableName) => {
    return metrics.map(metric => ({
      label: metric,
      value: metric,
      tableName: tableName
    }))
  }
}

const ANALYSIS_MODE_METADATA = {
  DEFAULT: 'maximumValue',

  minimumValue: {
    id: "minimumValue",
    value: "minimumValue",
    label: "Minimum Value",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  maximumValue: {
    id: "maximumValue",
    value: "maximumValue",
    label: "Maximum Value",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  averageValue: {
    id: "averageValue",
    value: "averageValue",
    label: "Average Value",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  firstValue: {
    id: "firstValue",
    value: "firstValue",
    label: "First Value",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  lastValue: {
    id: "lastValue",
    value: "lastValue",
    label: "Last Value",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  totalSum: {
    id: "totalSum",
    value: "totalSum",
    label: "Total Sum",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  totalCount: {
    id: "totalCount",
    value: "totalCount",
    label: "Total Count",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  uniqueCount: {
    id: "uniqueCount",
    value: "uniqueCount",
    label: "Unique Count",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  allTrue: {
    id: "allTrue",
    value: "allTrue",
    label: "All True (AND)",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  anyTrue: {
    id: "anyTrue",
    value: "anyTrue",
    label: "Any True (OR)",
    accordion: 'Basic',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  peakHourOfDay: {
    id: "peakHourOfDay",
    value: "peakHourOfDay",
    label: "Peak Hour-of-Day",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  topNContributors: {
    id: "topNContributors",
    value: "topNContributors",
    label: "Top-N Contributors",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  rollingNDayAverage: {
    id: "rollingNDayAverage",
    value: "rollingNDayAverage",
    label: "Rolling N-Day Average",
    accordion: 'Advanced',
    fields: ["metric", "windowDays"],
    query: QUERY_TEMPLATES.minimumValue
  },
  nthPercentile: {
    id: "nthPercentile",
    value: "nthPercentile",
    label: "Nth Percentile",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  dayOverDayChange: {
    id: "dayOverDayChange",
    value: "dayOverDayChange",
    label: "Day Over Day Change",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  weekOverWeekChange: {
    id: "weekOverWeekChange",
    value: "weekOverWeekChange",
    label: "Week Over Week Change",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  cumulativeTotal: {
    id: "cumulativeTotal",
    value: "cumulativeTotal",
    label: "Cumulative Total",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  ratioOfTwoMetrics: {
    id: "ratioOfTwoMetrics",
    value: "ratioOfTwoMetrics",
    label: "Ratio of Two Metrics",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  slaBreachesAboveThreshold: {
    id: "slaBreachesAboveThreshold",
    value: "slaBreachesAboveThreshold",
    label: "SLA Breaches Above Threshold",
    accordion: 'Advanced',
    fields: ["metric", "threshold", "comparator"],
    query: QUERY_TEMPLATES.minimumValue
  },
  anomaly: {
    id: "anomaly",
    value: "anomaly",
    label: "Anomaly",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  seasonalityHeatmap: {
    id: "seasonalityHeatmap",
    value: "seasonalityHeatmap",
    label: "Seasonality Heatmap",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  trendline: {
    id: "trendline",
    value: "trendline",
    label: "Trendline",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  compareToTarget: {
    id: "compareToTarget",
    value: "compareToTarget",
    label: "Compare to Target",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  sumColumns: {
    id: "sumColumns",
    value: "sumColumns",
    label: "Sum Columns",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  subtractColumns: {
    id: "subtractColumns",
    value: "subtractColumns",
    label: "Subtract Columns",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  multiplyColumns: {
    id: "multiplyColumns",
    value: "multiplyColumns",
    label: "Multiply Columns",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  divideColumns: {
    id: "divideColumns",
    value: "divideColumns",
    label: "Divide Columns",
    accordion: 'Advanced',
    fields: ["metric"],
    query: QUERY_TEMPLATES.minimumValue
  },
  customSql: {
    id: "customSql",
    value: "customSql",
    label: "Custom SQL",
    accordion: 'Expert',
    fields: ["sqlTextArea"],
    query: QUERY_TEMPLATES.customSql
  }
}

export const ANALYSIS_MODE = {
  ...ANALYSIS_MODE_METADATA,

  BASIC_OPTIONS: [
    ANALYSIS_MODE_METADATA.minimumValue,
    ANALYSIS_MODE_METADATA.maximumValue,
    ANALYSIS_MODE_METADATA.averageValue,
    ANALYSIS_MODE_METADATA.firstValue,
    ANALYSIS_MODE_METADATA.lastValue,
    ANALYSIS_MODE_METADATA.totalSum,
    ANALYSIS_MODE_METADATA.totalCount,
    ANALYSIS_MODE_METADATA.uniqueCount,
    ANALYSIS_MODE_METADATA.allTrue,
    ANALYSIS_MODE_METADATA.anyTrue,
  ],

  ADVANCED_OPTIONS: [
    ANALYSIS_MODE_METADATA.peakHourOfDay,
    ANALYSIS_MODE_METADATA.topNContributors,
    ANALYSIS_MODE_METADATA.rollingNDayAverage,
    ANALYSIS_MODE_METADATA.nthPercentile,
    ANALYSIS_MODE_METADATA.dayOverDayChange,
    ANALYSIS_MODE_METADATA.weekOverWeekChange,
    ANALYSIS_MODE_METADATA.cumulativeTotal,
    ANALYSIS_MODE_METADATA.ratioOfTwoMetrics,
    ANALYSIS_MODE_METADATA.slaBreachesAboveThreshold,
    ANALYSIS_MODE_METADATA.anomaly,
    ANALYSIS_MODE_METADATA.seasonalityHeatmap,
    ANALYSIS_MODE_METADATA.trendline,
    ANALYSIS_MODE_METADATA.compareToTarget,
    ANALYSIS_MODE_METADATA.sumColumns,
    ANALYSIS_MODE_METADATA.subtractColumns,
    ANALYSIS_MODE_METADATA.multiplyColumns,
    ANALYSIS_MODE_METADATA.divideColumns,
  ],

  EXPERT_OPTIONS: [
    ANALYSIS_MODE_METADATA.customSql
  ],

  VALUES: {
    streamId: '',
    streamLabel: {
      value: '',
      color: '#2184f9'
    },
    enableTrendline: false,
    analysisMode: ANALYSIS_MODE_METADATA.DEFAULT, // ANALYSIS_MODE.METADATA key/id
    schema: '',
    table: '',
    metric: {
      selectedTableName: '',
      metrics: [],
      metricConfig: {}
    },
    groupBy: {
      selectedTableName: '',
      metrics: [],
      metricConfig: {}
    },
    numerator: {
      selectedTableName: '',
      metrics: [],
      metricConfig: {}
    },
    denominator: {
      selectedTableName: '',
      metrics: [],
      metricConfig: {}
    },
    topN: 5,
    windowDays: 7,
    percentile: 0.9,
    coloring: CHART_COLORING.DEFAULT,
    colorTiers: {
      value: COLOR_TIERS.DEFAULT,
      tiers: {
        0: {
          value: 0,
          color: ''
        },
        1: {
          value: 0,
          color: ''
        },
        2: {
          value: 0,
          color: ''
        }
      }
    },
    comparator: COMPARATOR.DEFAULT,
    thresholdType: CHART_THRESHOLD_TYPE.LABEL_OPTIONS,
    tableThresholdType: CHART_THRESHOLD_TYPE.DEFAULT,
    targetValue: 0,
    sqlTextArea: '',
  }
}

export const CHART_DEFAULT_VALUES = {
  version: '2.0',
  chartTitle: '',
  chartType: CHART_TYPE.DEFAULT,
  format: CHART_FORMAT_SELECTOR.DEFAULT,
  decimal: CHART_DECIMAL.DEFAULT,
  lineWidth: CHART_LINE_WIDTH.DEFAULT,
  axisStep: '',
  prefix: '',
  suffix: '',
  fontSize: CHART_FONT_SIZE.DEFAULT,
  thresholdType: CHART_THRESHOLD_TYPE.DEFAULT,
  devices: [],
  timeRange: RELATIVE_TIME_RANGE.CHART_DEFAULT,
  dataPoint: 'avg',
  chartDateFormat: CHART_DATE_FORMAT.DEFAULT,
  coloring: CHART_COLORING.DEFAULT,
  labelRotation: CHART_LABEL_ROTATION.DEFAULT,
  xAxisStep: CHART_XAXIS_STEP.DEFAULT,
  yAxisMin: null,
  breakdownType: CHART_BREAKDOWN_TYPE.DEFAULT,
  colorMode: CHART_MODE.DEFAULT,
  yAxisMax: '',
  colorTiers: {
    value: COLOR_TIERS.DEFAULT,
    tiers: {
      0: {
        value: 0,
        color: ''
      },
      1: {
        value: 0,
        color: ''
      },
      2: {
        value: 0,
        color: ''
      }
    },
    customConfigs: []
  },
  groupBy: {
    selectedTableName: '',
    metrics: [],
    metricConfig: {}
  },
  metric: {
    selectedTableName: '',
    metrics: [],
    metricConfig: {}
  },
  legend: CHART_LEGEND.DEFAULT,
  dataStreams: {
    value: 1,
    streams: [
      { ...ANALYSIS_MODE.VALUES }
    ]
  },
  dataStreamSingle: { ...ANALYSIS_MODE.VALUES, breakdownType: 'compare_streams' },
  dataStreamCard: { ...ANALYSIS_MODE.VALUES, breakdownType: 'compare_streams' },
  enableYAxisTitle: false,
  yAxisTitle: '',
  enableXAxisTitle: false,
  xAxisTitle: '',
  chartLayout: CHART_LAYOUT.DEFAULT,
  enableMapLabels: false,
  enableThreshold: false,
  thresholdName: '',
  allThresholdType: CHART_THRESHOLD_TYPE.DEFAULT,
  thresholdType: CHART_THRESHOLD_TYPE.DEFAULT,
  thresholdConfig: {
    value: 80,
    color: '#2184f9'
  },
  tableColumnTitle: '',
  tableColumnMetricData: 'raw',
  intervalTitle: '',
  cardType: {
    name: CARD_TYPE.DEFAULT,
    range: {
      min: 0,
      max: 100
    }
  },
  mapType: MAP_TYPE.DEFAULT,
  enableDataTitle: false,
  dataTitle: '',
  enableLabels: true,
  enablePieChartLabels: false,
  labelDisplay: '',
  sqlQuery: '',
  analysisInterval: {
    quantity: 1,
    value: CHART_INTERVAL.DEFAULT
  },
  minimumValue: 'auto',
  maximumValue: 'auto',
  xAxisStep: CHART_XAXIS_STEP.DEFAULT,
  decimal: CHART_DECIMAL.DEFAULT,
}

export const FIELD_TYPE = {
  CHART_TYPE: 'chartType',
  METRIC: 'metric',
  METRIC_WITH_GROUP: 'metricWithGroup',
  TEXT: 'text',
  NUMBER: 'number',
  TEXT_AREA: 'textArea',
  MULTI_SELECT: 'multiSelect',
  SELECT: 'select',
  TOGGLE_BUTTON: 'toggleButton',
  DATA_STREAMS: 'dataStreams',
  DATA_STREAMS_SINGLE: 'dataStreamsSingle',
  DATA_STREAMS_CARD: 'dataStreamsCard',
  DATE: 'date',
  DEVICES: 'devices',
  TEXT_COLOR: 'textColor', // customConfig
  COLOR_TIERS: 'colorTiers',
  ANALYSIS_INTERVAL: 'analysisInterval',
  CARD_TYPE: 'cardType',
  DATA_SOURCE: 'dataSource',
  BRIEFING_DATA: 'briefingData',
  KEY_FINDING: 'key_finding'
}

export const CHART_DEFINITION_FIELDS = {
  chartTitle: {
    id: 'title',
    type: FIELD_TYPE.TEXT,
    label: 'Chart title',
    placeholder: 'Display text'
  },
  chartType: {
    id: 'chartType',
    type: FIELD_TYPE.CHART_TYPE,
    label: 'Chart type',
    placeholder: 'Select chart type',
    options: [...CHART_TYPE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  format: {
    id: 'format',
    type: FIELD_TYPE.SELECT,
    label: 'Format',
    placeholder: 'Select format',
    options: [...CHART_FORMAT_SELECTOR.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  timeGrid: {
    id: 'timeGrid',
    type: FIELD_TYPE.SELECT,
    label: 'Time Grid',
    placeholder: 'Select format',
    options: [...CHART_TIME_GRID_SELECTOR.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: [],
    selectedOption: [...CHART_TIME_GRID_SELECTOR.OPTIONS].find(opt => opt.value === CHART_TIME_GRID_SELECTOR.DEFAULT),
  },
  dateFormat: {
    id: 'dateFormat',
    type: FIELD_TYPE.SELECT,
    label: 'Date format',
    hasBorder: true,
    placeholder: 'Select time format',
    options: [...CHART_DATE_FORMAT2.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: [],
    selectedOption: [...CHART_DATE_FORMAT2.OPTIONS].find(opt => opt.value === CHART_DATE_FORMAT2.DEFAULT),
    getDynamicOptions: (formData) => {
      const timeGrid = formData?.timeGrid || CHART_TIME_GRID_SELECTOR.DEFAULT;
      return getDateFormatOptionsByTimeGrid(timeGrid);
    },
    getDefaultValue: (formData) => {
      const timeGrid = formData?.timeGrid || CHART_TIME_GRID_SELECTOR.DEFAULT;
      const options = getDateFormatOptionsByTimeGrid(timeGrid);
      return options.length > 0 ? options[0].value : CHART_DATE_FORMAT2.DEFAULT;
    },
  },
  xAxisRotation: {
    id: 'dateFormat',
    type: FIELD_TYPE.SELECT,
    label: 'X-axis rotation',
    hasBorder: true,
    placeholder: 'X-axis rotation',
    options: [...CHART_LABEL_ROTATION.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: [],
    selectedOption: [...CHART_LABEL_ROTATION.OPTIONS].find(opt => opt.value === CHART_LABEL_ROTATION.DEFAULT),
  },
  fontSize: {
    id: 'fontSize',
    type: FIELD_TYPE.SELECT,
    label: 'Font size',
    placeholder: 'Select font size',
    options: [...CHART_FONT_SIZE.OPTIONS],
  },
  lineWidth: {
    id: 'lineWidth',
    type: FIELD_TYPE.SELECT,
    label: 'Line width',
    placeholder: 'Select line width',
    options: [...CHART_LINE_WIDTH.OPTIONS],
  },
  breakdownType: {
    id: 'breakdownType',
    type: FIELD_TYPE.SELECT,
    label: 'Breakdown type',
    placeholder: 'Select breakdown type',
    options: [...CHART_BREAKDOWN_TYPE.OPTIONS],
  },
  yAxisMin: {
    id: 'yAxisMin',
    type: FIELD_TYPE.NUMBER,
    label: 'Minimum value',
    placeholder: '0 (default)'
  },
  yAxisMax: {
    id: 'yAxisMax',
    type: FIELD_TYPE.NUMBER,
    label: 'Maximum value',
    placeholder: 'Auto (default)'
  },
  axisStep: {
    id: 'axisStep',
    type: FIELD_TYPE.NUMBER,
    label: 'Axis step',
    placeholder: 'Auto (default)'
  },
  decimal: {
    id: 'decimal',
    type: FIELD_TYPE.SELECT,
    label: 'Decimals',
    hasBorder: true,
    placeholder: 'Select decimal',
    // Ensure the default "From data" option is pre-selected and shown
    selectedOption: [...CHART_DECIMAL.OPTIONS].find(opt => opt.value === CHART_DECIMAL.DEFAULT),
    options: [...CHART_DECIMAL.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  xAxisStep: {
    id: 'xAxisStep',
    type: FIELD_TYPE.SELECT,
    label: 'Axis step',
    placeholder: 'Select axis step',
    options: [...CHART_XAXIS_STEP.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  labelRotation: {
    id: 'labelRotation',
    type: FIELD_TYPE.SELECT,
    label: 'Label rotation',
    placeholder: 'Select label rotation',
    options: [...CHART_LABEL_ROTATION.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  prefix: {
    id: 'prefix',
    type: FIELD_TYPE.TEXT,
    label: 'Prefix',
    placeholder: 'None',
    hasBorder: true
  },
  suffix: {
    id: 'suffix',
    type: FIELD_TYPE.TEXT,
    label: 'Suffix',
    placeholder: 'None',
    hasBorder: true
  },
  thresholdType: {
    id: 'thresholdType',
    type: FIELD_TYPE.SELECT,
    label: 'Threshold type',
    placeholder: 'Select threshold type',
    options: [...CHART_THRESHOLD_TYPE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  allThresholdType: {
    id: 'allThresholdType',
    type: FIELD_TYPE.SELECT,
    label: 'Threshold type',
    placeholder: 'Select threshold type',
    options: [...CHART_THRESHOLD_TYPE.LABEL_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  devices: {
    id: 'devices',
    type: FIELD_TYPE.DEVICES,
    label: 'Devices',
    placeholder: 'Dashboard default',
    options: [],
    enableCustomConfigs: true,
    customConfigs: []
  },
  timeRange: {
    id: 'timeRange',
    type: FIELD_TYPE.DATE,
    label: 'Date range',
    placeholder: 'Dashboard default',
    options: [],
    enableCustomConfigs: false,
    customConfigs: []
  },
  dateRange: {
    id: 'dateRange',
    type: FIELD_TYPE.DATE,
    label: 'Date range',
    placeholder: 'Dashboard default',
    options: [],
    enableCustomConfigs: false,
    customConfigs: []
  },
  chartInterval: {
    id: 'chartInterval',
    type: FIELD_TYPE.SELECT,
    label: 'Chart interval',
    placeholder: 'Chart interval',
    options: [...CHART_INTERVAL.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  intervalQuantity: {
    id: 'intervalQuantity',
    type: FIELD_TYPE.TEXT,
    label: 'Interval Quantity',
    placeholder: ''
  },
  chartDateFormat: {
    id: 'chartDateFormat',
    type: FIELD_TYPE.SELECT,
    label: 'Time format',
    placeholder: 'Select time format',
    options: [...CHART_DATE_FORMAT.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  colorMode: {
    id: 'colorMode',
    type: FIELD_TYPE.SELECT,
    label: 'Mode',
    selectedOption: [...CHART_MODE.OPTIONS].find(opt => opt.value === CHART_MODE.DEFAULT),
    placeholder: 'Select mode',
    options: [...CHART_MODE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  coloringType: {
    id: 'coloringType',
    type: FIELD_TYPE.SELECT,
    label: 'Coloring Type',
    options: [...COLORING_TYPE.OPTIONS],
    placeholder: 'Select coloring type',
    selectedOption: [...COLORING_TYPE.OPTIONS].find(opt => opt.value === COLORING_TYPE.DEFAULT),
    enableCustomConfigs: false,
    customConfigs: []
  },
  coloring: {
    id: 'coloring',
    type: FIELD_TYPE.SELECT,
    label: 'Coloring',
    placeholder: 'Select coloring',
    options: [...CHART_COLORING.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  colorTiers: {
    id: 'colorTiers',
    type: FIELD_TYPE.COLOR_TIERS,
    label: 'Color tiers',
    placeholder: 'Select color tiers',
    options: [...COLOR_TIERS.OPTIONS],
    enableCustomConfigs: true,
    customConfigs: [
      {
        color: '',
        value: 0,
        label: ''
      }
    ],
  },
  groupBy: {
    id: 'groupBy',
    type: FIELD_TYPE.METRIC,
    label: 'Group by',
    placeholder: '',
    options: [],
    // showSubConfig: true,
    enableCustomConfigs: false,
    customConfigs: []
  },
  metricWithGroup: {
    id: 'groupByMetric',
    type: FIELD_TYPE.METRIC_WITH_GROUP,
    label: 'Metric',
    placeholder: 'Select metric',
    options: [],
    showSubConfig: true,
    enableCustomConfigs: false,
    customConfigs: []
  },
  metricWithChild: {
    id: 'metric',
    type: FIELD_TYPE.METRIC,
    label: 'Metrics',
    placeholder: '',
    options: [],
    showSubConfig: true,
    enableCustomConfigs: false,
    customConfigs: []
  },
  legend: {
    id: 'legend',
    type: FIELD_TYPE.SELECT,
    label: 'Legend position',
    placeholder: 'Select legend position',
    options: [...CHART_LEGEND.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  dataStreams: {
    id: 'dataStreams',
    type: FIELD_TYPE.DATA_STREAMS,
  },
  // Chart-specific dataStreams field overrides
  dataStreamSingle: {
    id: 'dataStreamsSingle',
    type: FIELD_TYPE.DATA_STREAMS_SINGLE,
  },
  dataStreamCard: {
    id: 'dataStreamCard',
    type: FIELD_TYPE.DATA_STREAMS_CARD,
  },
  metric: {
    id: 'metric',
    type: FIELD_TYPE.METRIC,
    label: 'Metric',
    placeholder: 'Select metrics',
    options: [],
    enableCustomConfigs: true,
    customConfigs: []
  },
  monoColor: {
    id: 'monoColor',
    type: FIELD_TYPE.SINGLE_COLOR_SELECTOR,
    label: 'Heatmap color',
    placeholder: 'Heatmap label',
    enableCustomConfigs: true,
    customConfigs: []
  },
  groupByMetric: {
    id: 'groupByMetric',
    type: FIELD_TYPE.METRIC,
    label: 'Group by',
    placeholder: 'Select groups',
    options: [],
    showSubConfig: true,
    enableCustomConfigs: true,
    customConfigs: []
  },
  enableYAxisTitle: {
    id: 'enableYAxisTitle',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Show axis title',
    targetFieldIds: ['yAxisTitle']
  },
  yAxisTitle: {
    id: 'yAxisTitle',
    type: FIELD_TYPE.TEXT,
    label: 'Y-axis title',
    placeholder: 'Title Name'
  },
  enableXAxisTitle: {
    id: 'enableXAxisTitle',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Enable title',
    targetFieldIds: ['xAxisTitle']
  },
  xAxisTitle: {
    id: 'xAxisTitle',
    type: FIELD_TYPE.TEXT,
    label: 'X-axis title',
    placeholder: 'Title Name'
  },
  chartLayout: {
    id: 'chartLayout',
    type: FIELD_TYPE.SELECT,
    label: 'Chart layout',
    placeholder: 'Select chart layout',
    options: [...CHART_LAYOUT.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  enableThreshold: {
    id: 'enableThreshold',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Enable threshold',
    targetFieldIds: ['thresholdName', 'thresholdType', 'allThresholdType', 'thresholdConfig', 'colorTiers']
  },
  showValue: {
    id: 'showValue',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Show values',
    targetFieldIds: ['format', 'decimal', 'prefix', 'suffix']

  },
  thresholdName: {
    id: 'thresholdName',
    type: FIELD_TYPE.TEXT,
    label: 'Threshold name'
  },
  thresholdConfig: {
    type: FIELD_TYPE.TEXT_COLOR,
    placeholder: '',
    id: 'thresholdConfig',
    label: 'Threshold',
    hasBorder: true
  },
  tableColumnTitle: {
    id: 'tableColumnTitle',
    type: FIELD_TYPE.TEXT,
    label: 'Column title',
    placeholder: 'Title name',
  },
  tableColumnMetricData: {
    id: 'tableColumnMetricData',
    type: FIELD_TYPE.SELECT,
    label: 'Data mode',
    placeholder: 'Set data point',
    targetFieldIds: ['dataPoint'],
    options: [...DATA_MODE.OPTIONS],
    enableCustomConfigs: true,
    customConfigs: []
  },
  analysisInterval: {
    id: 'analysisInterval',
    label: 'Analysis Interval',
    type: FIELD_TYPE.ANALYSIS_INTERVAL,
    placeholder: '',
    options: [...CHART_INTERVAL.OPTIONS]
  },
  intervalTitle: {
    id: 'intervalTitle',
    type: FIELD_TYPE.TEXT,
    label: 'Interval title',
    placeholder: 'Display text',
  },
  cardType: {
    id: 'cardType',
    type: FIELD_TYPE.CARD_TYPE,
    label: 'Card type',
    placeholder: '',
    options: [...CARD_TYPE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: [],
  },
  mapType: {
    id: 'mapType',
    type: FIELD_TYPE.SELECT,
    label: 'Map type',
    placeholder: '',
    options: [...MAP_TYPE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: [],
  },
  enableDataTitle: {
    id: 'enableDataTitle',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Show data title',
    targetFieldIds: ['dataTitle']
  },
  dataTitle: {
    id: 'dataTitle',
    type: FIELD_TYPE.TEXT,
    label: 'Data title',
    placeholder: 'Display text'
  },
  enableLabels: {
    id: 'enableLabels',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Always show labels',
    targetFieldIds: ['labelDisplay']
  },
  enablePieChartLabels: {
    id: 'enablePieChartLabels',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Always show labels',
    targetFieldIds: ['labelDisplay']
  },
  enableMapLabels: {
    id: 'enableMapLabels',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Always show labels',
    targetFieldIds: ['labelDisplay']
  },
  labelDisplay: {
    id: 'labelDisplay',
    type: FIELD_TYPE.SELECT,
    label: 'Display',
    placeholder: '',
    options: [...LABEL_DISPLAY.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  formatSelector: {
    id: 'formatSelector',
    type: FIELD_TYPE.SELECT,
    label: 'Format',
    placeholder: '',
    options: [...CHART_FORMAT_SELECTOR.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  streamLabel: {
    id: 'streamLabel',
    type: FIELD_TYPE.TEXT_COLOR,
    label: 'Label',
    placeholder: ''
  },
  enableTrendline: {
    id: 'enableTrendline',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Enable Trendline',
    targetFieldIds: ['trendline']
  },
  analysisMode: {
    id: 'analysisMode',
    type: FIELD_TYPE.SELECT,
    label: 'Analysis mode',
    placeholder: '',
    isSearchable: true,
    options: [
      ...ANALYSIS_MODE.BASIC_OPTIONS,
      ...ANALYSIS_MODE.ADVANCED_OPTIONS.filter(opt => ![
        //'peakHourOfDay',
        'topNContributors',
        //'rollingNDayAverage',
        'nthPercentile',
        'dayOverDayChange',
        'weekOverWeekChange',
        'ratioOfTwoMetrics',
        'slaBreachesAboveThreshold',
        'anomaly',
        'seasonalityHeatmap',
        'trendline',
        'compareToTarget',
      ].includes(opt.value))
    ]
  },
  numerator: {
    id: 'numerator',
    type: FIELD_TYPE.METRIC,
    label: "Numerator",
    placeholder: ''
  },
  denominator: {
    id: 'denominator',
    type: FIELD_TYPE.METRIC,
    label: "Denominator",
    placeholder: ''
  },
  topN: {
    id: 'topN',
    type: FIELD_TYPE.NUMBER,
    label: "Top N",
    placeholder: ''
  },
  windowDays: {
    id: 'windowDays',
    type: FIELD_TYPE.NUMBER,
    label: "Window (days)",
    placeholder: ''
  },
  percentile: {
    id: 'percentile',
    type: FIELD_TYPE.NUMBER,
    label: "Percentile",
    min: 0,
    max: 1,
    placeholder: ''
  },
  comparator: {
    id: 'comparator',
    type: FIELD_TYPE.SELECT,
    label: "Comparator",
    options: [...COMPARATOR.OPTIONS],
    placeholder: ''
  },
  threshold: {
    id: 'threshold',
    type: FIELD_TYPE.NUMBER,
    label: "Threshold"
  },
  targetValue: {
    id: 'targetValue',
    type: FIELD_TYPE.NUMBER,
    label: 'Target value',
    placeholder: ''
  },
  sqlTextArea: {
    id: 'sqlTextArea',
    type: FIELD_TYPE.TEXT_AREA,
    label: '',
    placeholder: ''
  },
  dataSource: {
    id: 'dataSource',
    type: FIELD_TYPE.DATA_SOURCE,
    label: 'Data Source',
    placeholder: 'Select chart layout',
    options: [...CHART_DATA_SOURCE.OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  instruction: {
    id: 'instruction',
    type: FIELD_TYPE.TEXT_AREA_V2,
    label: 'Instruction',
    placeholder: 'Add instruction'
  },
  textSize: {
    id: 'textSize',
    type: FIELD_TYPE.SELECT,
    label: 'Text size',
    placeholder: 'Select text size',
    options: [...CHART_FONT_SIZE.OPTIONS],
  },
  highlightKeyItems: {
    id: 'highlightKeyItems',
    type: FIELD_TYPE.TOGGLE_BUTTON,
    label: 'Highlight key items',
    targetFieldIds: ['']
  },
  briefingData: {
    id: 'briefingData',
    type: FIELD_TYPE.BRIEFING_DATA,
    label: 'briefing data',
  },
  keyFinding: {
    id: 'keyFinding',
    type: FIELD_TYPE.KEY_FINDING,
    label: 'key finding',
  },
  include: {
    id: 'include',
    type: FIELD_TYPE.SELECT_INPUT_V2,
    label: 'Include',
    options: []
  }

}

export const CHART_SECTIONS = {
  [CHART_TYPE.LINE]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['analysisInterval', 'dataStreams'],
    },
    {
      title: 'Y-Axis',
      fields: [
        'lineWidth',
        'yAxisMin',
        'yAxisMax',
        'axisStep',
        'enableYAxisTitle',
        'yAxisTitle',
        'chartLayout',
        'format',
        'decimal',
        'prefix',
        'suffix',
        'enableThreshold',
        'thresholdName',
        'thresholdType',
        'thresholdConfig'
      ]
    },
    {
      title: 'X-Axis',
      fields: ['enableXAxisTitle', 'xAxisTitle', 'groupBy'],
      conditionalFields: {
        fieldCondition: 'groupBy.metrics[0]',
        time: ['chartDateFormat', 'xAxisStep', 'labelRotation'],
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.AREA]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['analysisInterval', 'dataStreams'],
    },
    {
      title: 'Y-Axis',
      fields: [
        'lineWidth',
        'yAxisMin',
        'yAxisMax',
        'axisStep',
        'enableYAxisTitle',
        'yAxisTitle',
        'chartLayout',
        'format',
        'decimal',
        'prefix',
        'suffix',
        'enableThreshold',
        'thresholdName',
        'thresholdType',
        'thresholdConfig'
      ]
    },
    {
      title: 'X-Axis',
      fields: ['enableXAxisTitle', 'xAxisTitle', 'groupBy'],
      conditionalFields: {
        fieldCondition: 'groupBy.metrics[0]',
        time: ['chartDateFormat', 'xAxisStep', 'labelRotation'],
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.BAR]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['analysisInterval', 'dataStreams'],
    },
    {
      title: 'Y-Axis',
      fields: [
        'lineWidth',
        'yAxisMin',
        'yAxisMax',
        'axisStep',
        'enableYAxisTitle',
        'yAxisTitle',
        'chartLayout',
        'format',
        'decimal',
        'prefix',
        'suffix',
        'enableThreshold',
        'thresholdName',
        'thresholdType',
        'thresholdConfig'
      ]
    },
    {
      title: 'X-Axis',
      fields: ['enableXAxisTitle', 'xAxisTitle', 'groupBy'],
      conditionalFields: {
        fieldCondition: 'groupBy.metrics[0]',
        time: ['chartDateFormat', 'xAxisStep', 'labelRotation'],
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.PIE]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      // fields: ['breakdownType', 'analysisMode'],
      // conditionalFields: {
      //   fieldCondition: 'breakdownType',
      //   by_category: ['metricWithGroup'],
      //   compare_metrics: ['metricWithChild']
      // }
      fields: ['dataStreamSingle'],
    },
    {
      title: 'Config',
      fields: [
        'enableDataTitle',
        'dataTitle',
        'format',
        'decimal',
        'prefix',
        'suffix',
        'enablePieChartLabels',
        // 'enableThreshold',
        // 'thresholdType',
        // 'colorTiers'
      ],
      conditionalFields: {
        fieldCondition: 'formatSelector',
        raw: ['decimal', 'prefix', 'suffix'],
        // compare_metrics: ['analysisMode', 'metricWithChild']
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.DOUGHNUT]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['dataStreamSingle'],
    },
    {
      title: 'Config',
      fields: [
        'enableDataTitle',
        'dataTitle',
        'format',
        'decimal',
        'prefix',
        'suffix',
        // 'enableLabels',
        // 'enableThreshold',
        // 'thresholdType',
        // 'colorTiers'
      ]
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.GAUGE]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['dataStreamSingle'],
    },
    {
      title: 'Config',
      fields: [
        // 'groupBy',
        'enableDataTitle',
        'dataTitle',
        'format',
        'decimal',
        'prefix',
        'suffix',
        // 'enableLabels',
        'enableThreshold',
        'thresholdType',
        'colorTiers'
      ]
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.TABLE]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle'],
    },
    {
      title: 'Columns',
      fields: ['tableColumnMetricData'],
      fieldCondition: 'tableColumnMetricData',
      conditionalFields: {
        fieldCondition: 'tableColumnMetricData',
        raw: ['dataStreams'],
        aggregated: ['analysisInterval', 'chartDateFormat', 'dataStreams']
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.CARD]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle'],
    },
    {
      title: 'Data',
      fields: ['dataStreamCard'],
    },
    {
      title: 'Card',
      fields: ['cardType', 'fontSize', 'format', 'decimal', 'prefix', 'suffix', 'enableThreshold', 'allThresholdType', 'colorTiers']
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.HEATMAP]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle', 'legend'],
    },
    {
      title: 'Data',
      fields: ['dataStreamCard'],
    },
    {
      title: 'Heat Map',
      fields: ['timeGrid', 'dateFormat', 'xAxisRotation', 'showValue', 'format', 'decimal', 'prefix', 'suffix', 'colorMode'],
      conditionalFields: {
        fieldCondition: 'colorMode',
        multi: ['coloringType', 'colorTiers']
      }
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.MAP]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle'],
    },
    {
      title: 'Data',
      fields: ['dataStreamCard'],
    },
    {
      title: 'Map',
      fields: ['mapType', 'format', 'decimal', 'prefix', 'suffix', 'enableMapLabels', 'enableThreshold', 'allThresholdType', 'colorTiers']
    },
    {
      title: 'Scope',
      fields: ['devices', 'timeRange']
    }
  ],
  [CHART_TYPE.INSIGHTS]: [
    {
      title: 'Chart',
      fields: ['chartType', 'chartTitle'],
    },
    {
      title: 'Data',
      fields: ['dataSource'],
    },
    {
      title: 'Content',
      fields: ['briefingData'],
    },
  ],
}


